<template>
    <div id="accueil">
        <div class="row">

            <!--Section de gauche-->
            <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 backInfoMain">
                <div class="">Bienvenu dans Finance par Logiciel Servex !</div>

                <br/>
                <br/>
                <br/>
                <h1>DASHBOARD</h1> 
                <br/>

                Expiration  : {{ getExpirationDate }} <br/>
                isAuthenticated : {{ isAuthenticated }} <br/>

                user : <pre>{{ getUser }}</pre>
            </div><!--FIN section de gauche-->

            <!--Section de droite-->
            <div class="col-xs-5 col-sm-5 col-md-5 col-lg-6 col-xl-6 backInfoMain">
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <button class="m-2 p-2" @click="loadData">Charger les données dans la store</button><br/>
                <button class="m-2 p-2" @click="clearData">Effacer les données de la store</button><br/>
                AllData :
                <pre>{{ getAllData }}</pre>
                <!--<pre>{{ JSON.stringify(getCompteGL, null, 2) }}</pre>-->
            </div><!--FIN - Section de droite-->

            <br><br>
            
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataService} from '@/services'

export default{
    name: "dashboard",
    components: {
            
    },
    methods: {
      async loadData() {
        await dataService.loadData()
      },
      clearData() {
        dataService.clearData()
      }
    },
    computed: {
        ...mapGetters(['getUser','getUserId','isAuthenticated','getExpirationDate','getAllData']),
    }
}
</script>

<style lang="scss" scoped>
//@import 'http://24.49.235.186:5012/assets/css/aaa.css';
//@import 'http://24.49.235.186:5012/assets/scss/color2.scss';
//@import 'http://www.servexpos.dev/assets/css/aaa.css';

.ttt{
    border: 2px black;
    text-align: left;
    background: red;
}
.ttt2{
    border: 2px black;
    text-align: left;
    background: blue;
    color: white;
}
.ttt3{
    color: red;
}

</style>